<template>
  <v-card :loading="$store.getters.GET_LOADING"
          tile :min-height="$vuetify.breakpoint.height / 1.8">
    <v-card-text class="ma-0 pa-0">
      <v-row class="ma-0 pa-0">
        <v-col cols="12" class="d-flex justify-center align-center ma-0 pt-0">
          <template v-if="!$store.getters.GET_LOADING && cities.length === 0 || !$store.getters.GET_LOADING && countries.length === 0 ">
            <div class="d-flex align-center justify-center" :style="`width: 100%; min-height: ${$vuetify.breakpoint.height / 1.8}px`">
              <span class="text-h4">{{ $t('notAvailable') }}</span>
            </div>
          </template>
        </v-col>
        <v-col cols="12" class="d-flex justify-center align-center ma-0 pt-0">
          <div v-show="!$store.getters.GET_LOADING && cities.length > 0" style="width: 100%" class="ma-0 pa-0">
            <v-card-title class="secondary--text">{{ $t('stats.city') }}</v-card-title>
            <div id="cities" :style="`width: 100%; min-height: ${$vuetify.breakpoint.height / 1.8}px`"></div>
          </div>
        </v-col>
        <v-col cols="12" class="d-flex justify-center align-center ma-0">
          <div v-show="!$store.getters.GET_LOADING && countries.length > 0" style="width: 100%"  class="ma-0 pa-0" >
            <v-card-title class="secondary--text">{{ $t('stats.country') }}</v-card-title>
            <div id="countries" :style="`width: 100%; min-height: ${$vuetify.breakpoint.height / 1.8}px`"></div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
/* eslint-disable no-unused-vars, camelcase */

import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_material from '@amcharts/amcharts4/themes/material'
export default {
  name: 'InfoPieChartComponent',
  data () {
    return {}
  },
  mounted () {
    this.$root.$on('build-stats', () => {
      this.buildChart('cities', ['count', 'city'], this.cities)
      this.buildChart('countries', ['count', 'country'], this.countries)
    })
  },
  methods: {
    buildChart (container, fields, data) {
      am4core.options.autoDispose = true
      am4core.options.queue = true
      am4core.useTheme(am4themes_material)

      const chart = am4core.create(container, am4charts.PieChart)
      const pieSeries = chart.series.push(new am4charts.PieSeries())

      pieSeries.dataFields.value = fields[0]
      pieSeries.dataFields.category = fields[1]

      chart.innerRadius = am4core.percent(30)
      pieSeries.slices.template.cursorOverStyle = [
        {
          property: 'cursor',
          value: 'pointer'
        }
      ]

      pieSeries.labels.template.radius = 3
      pieSeries.labels.template.padding(0, 0, 0, 0)

      chart.data = data
    }
  },
  computed: {
    cities () {
      return this.$store.getters.GET_STATISTIC.cities ? this.$store.getters.GET_STATISTIC.cities : []
    },
    countries () {
      return this.$store.getters.GET_STATISTIC.countries ? this.$store.getters.GET_STATISTIC.countries : []
    }
  }
}
</script>

<style scoped>

</style>
